import { Get, Post } from 'Xhr/Xhr';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { GetURLQuery } from 'utils/GetURLQuery';

const useCheckUniversityAuthorize = () => {
  const [needAuth, setNeedAuth] = useState();
  const pathData = useLocation();
  const currentPath = pathData.pathname;
  const code = GetURLQuery('code');

  const isUserPresent = !!Cookies.get('user')
    ? JSON.parse(Cookies.get('user'))
    : false;

  // console.log('isUserPresent==>', !!isUserPresent);


  // useEffect(()=>{
  //   Post('POST',`${process.env.REACT_APP_API_URL_API_RETURN_GET_TOKEN}`,false,{}).then((response)=>{
  //     console.log('response +=>',response)
  //   })
  // },[])

  useEffect(() => {
    Get(
      `${process.env.REACT_APP_API_URL_API_NEED_AUTHORIZE}`,
      false,
      {}
    ).then((response) => {
      if (!!isUserPresent) {
        return;
      }

      if (
        currentPath.toLocaleLowerCase() !== '/login' &&
        currentPath !== '/'
      ) {
        setNeedAuth(false);
        return;
      }
      setNeedAuth(response.data.Data);
    });
  }, []);

  useEffect(() => {
    if (
      needAuth !== undefined &&
      needAuth !== null &&
      needAuth === true
    ) {
      Post(
        'POST',
        `${process.env.REACT_APP_API_URL_API_AUTHORIZE_UNI}`,
        false,
        {}
      ).then((response) => {
        if (response.data.resCode === 1) {
          if (
            !code &&
            localStorage.getItem('sso_token') === null
          ) {
            window.location.href = response.data.Data;
          } else {
            if (code) {
              localStorage.setItem(
                'sso_token',
                JSON.stringify(code)
              );
            }
          }
        }
      });
    }
  }, [needAuth]);
};

export default useCheckUniversityAuthorize;
